import { z } from 'zod';
import theme from '../../theme';
import { ErrorMessages } from '../../utils/consts';

export const SignInSx = {
  backgroundImage: `url(${import.meta.env.VITE_DO_SPACE_URL}/assets/gradient-nautical-navy-rough-abstract-background-design%201.png)`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: '100dvh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const PaperSx = {
  width: 532,
  padding: '46px 40px 65px 40px',
};

export const TitleSx = {
  fontSize: '36px',
  marginTop: '2px',
  fontWeight: 600,
  letterSpacing: '1px',
  lineHeight: '40px',
  textAlign: 'center',
  color: theme.palette.customColors.gray[950],
};

export const ExplanationTextSx = {
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: theme.palette.customColors.gray[950],
  margin: '16px 0 40px 0',
  letterSpacing: 0,
};

export const ResetButtonSx = {
  height: '44px',
  width: '100%',
  backgroundColor: theme.palette.customColors.blue[500],
  '&.Mui-disabled': {
    color: theme.palette.common.white,
    opacity: 0.5,
    backgroundColor: theme.palette.customColors.blue[500],
  },
  marginTop: '32px',
};

export const CancelSx = {
  color: theme.palette.customColors.gray[950],
  marginTop: '26px',
  fontSize: '16px',
  textDecoration: 'underline',
  textUnderlineOffset: '3px',
  '&:hover': {
    color: theme.palette.customColors.blue[700],
  },
};

export const formSchema = z.object({
  email: z
    .string()
    .min(1, { message: ErrorMessages.FIELD_IS_REQUIRED })
    .email({ message: ErrorMessages.INVALID_EMAIL_FORMAT })
    .default(''),
});

export type FormData = z.infer<typeof formSchema>;
